const courseData = [
  {
    id: 1,
    image: require('../../assets/img/CareersInCyber/landing.jpg'),
    link: '/CareersInCyber',
    favorite: false,
    myCourses: false,
    status: 'published',

    access: 'pro',
    en_data: {
      category: 'Career & Industry',
      title: 'Careers in Cyber',
      description:
        'Discover diverse cybersecurity careers, essential skills, and industry opportunities today.',
      topics: [
        'Overview of Cyber Careers',
        'Educational Paths',
        'Industry Certifications',
        'Job Market Trends',
      ],
      difficulty: 'Beginner',
      state: 'pending',
    },
    ar_data: {
      category: 'المهنة والصناعة',
      title: 'المهن في الأمن السيبراني',
      description:
        'اكتشف مسارات مهنية متنوعة في الأمن السيبراني، والمهارات الأساسية، وفرص الصناعة اليوم.',
      topics: [
        'نظرة عامة على وظائف الأمن السيبراني',
        'المسارات التعليمية',
        'الشهادات الصناعية',
        'اتجاهات سوق العمل',
      ],
      difficulty: 'مبتدئ',
      state: 'قيد الانتظار',
    },
  },
  {
    id: 2,
    image: require('../../assets/img/Burp_Suit/BurpSuit_Content.png'),
    link: '/Burp_Suit',
    favorite: false,
    myCourses: false,
    status: 'published',

    access: 'free',
    en_data: {
      category: 'Tools & Techniques',
      title: 'Burp Suite',
      description:
        'Master Burp Suite fundamentals, empowering cybersecurity testing and vulnerability assessment.',
      topics: [
        'Learn about different careers in cyber',
        'Hack your first application',
        'Defend against a live cyber attack',
        'Explore security topics in the industry',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الأدوات والتقنيات',
      title: 'بورب سويت',
      description:
        'إتقان أساسيات Burp Suite، مما يمكّن من اختبار الأمن السيبراني وتقييم الثغرات.',
      topics: [
        'تعرف على المهن المختلفة في مجال الأمن السيبراني',
        'اخترق تطبيقك الأول',
        'الدفاع ضد هجوم إلكتروني مباشر',
        'استكشاف مواضيع الأمان في الصناعة',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 3,
    image: require('../../assets/img/cookies/Cookies_transparent.png'),
    link: '/cookies',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Cookies',
      description:
        'Understand cookies’ roles, security implications, storage methods, and manipulation techniques.',
      topics: [
        'What Are Cookies?',
        'What are Cookies Used For?',
        'Where are Cookies Stored?',
        'Cookies Manipulation',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'الكوكيز',
      description:
        'فهم دور الكوكيز، وتأثيراتها الأمنية، وطرق التخزين، وتقنيات التلاعب بها.',
      topics: [
        'ما هي الكوكيز؟',
        'ما استخدامات الكوكيز؟',
        'أين يتم تخزين الكوكيز؟',
        'التلاعب بالكوكيز',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 4,
    image: require('../../assets/img/SQL_Injection/landing3.png'),
    link: '/sql_Injection',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'SQL Injection',
      description:
        'Identify SQL injection flaws, extract hidden data, and secure applications.',
      topics: [
        'Retrieving hidden data',
        'SQL injection UNION attacks',
        'Finding columns with a useful data type',
        'Using a SQL injection UNION attack to retrieve interesting data',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الثغرات',
      title: 'حقن SQL',
      description:
        'تحديد ثغرات SQL Injection، استخراج البيانات المخفية، وتأمين التطبيقات.',
      topics: [
        'استرجاع البيانات المخفية',
        'هجمات SQL Injection UNION',
        'البحث عن الأعمدة ذات النوع المفيد',
        'استخدام هجوم SQL Injection UNION لاستخراج البيانات المثيرة للاهتمام',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 5,
    image: require('../../assets/img/Unrestricted File Upload/card_image.png'),
    link: '/UnrestrictedFileUpload',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Unrestricted File Upload',
      description:
        'Explore file upload risks, techniques, and methods to safeguard applications.',
      topics: [
        'What is Unrestricted File Upload?',
        'Why is it Dangerous?',
        'Attack Techniques',
        'Exploitation Scenarios',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الثغرات',
      title: 'تحميل الملفات غير المقيد',
      description:
        'استكشاف مخاطر تحميل الملفات، والتقنيات، وطرق حماية التطبيقات.',
      topics: [
        'ما هو تحميل الملفات غير المقيد؟',
        'لماذا هو خطير؟',
        'تقنيات الهجوم',
        'سيناريوهات الاستغلال',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 6,
    image: require('../../assets/img/linux/card_image.png'),
    link: '/linux',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Linux Fundamentals',
      description:
        'Build essential Linux skills, mastering commands, filesystem navigation and operations.',
      topics: [
        'Running Your First Few Commands',
        'Interacting with the Filesystem',
        'Searching for Files',
        'Introduction to Shell Operators',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'أساسيات لينكس',
      description:
        'بناء مهارات لينكس الأساسية، وإتقان الأوامر، والتنقل في نظام الملفات والعمليات.',
      topics: [
        'تشغيل أول الأوامر الخاصة بك',
        'التفاعل مع نظام الملفات',
        'البحث عن الملفات',
        'مقدمة لمشغلات الشل',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 7,
    image: require('../../assets/img/ACV/Landing.jpg'),
    link: '/AC_Vuln',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Access Control Vulnerabilities',
      description:
        'Learn to detect and mitigate access control vulnerabilities in applications.',
      topics: [
        'What are Access Control Vulnerabilities?',
        'Types of Access Control Flaws',
        'Exploitation Examples',
        'Mitigation Techniques',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الثغرات',
      title: 'ثغرات التحكم بالوصول',
      description:
        'تعلم كيفية اكتشاف وتخفيف ثغرات التحكم بالوصول في التطبيقات.',
      topics: [
        'ما هي ثغرات التحكم بالوصول؟',
        'أنواع عيوب التحكم بالوصول',
        'أمثلة على الاستغلال',
        'تقنيات التخفيف',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 8,
    image: require('../../assets/img/Broken Authentication/card_image.png'),
    link: '/broken-auth',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Broken Authentication',
      description:
        'Secure authentication mechanisms to prevent account takeovers and data breaches.',
      topics: [
        'Weak Passwords',
        'Session Management Issues',
        'Lack of MFA',
        'Credential Stuffing',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الثغرات',
      title: 'المصادقة المعطوبة',
      description: 'تأمين آليات المصادقة لمنع اختراق الحسابات وتسرب البيانات.',
      topics: [
        'كلمات مرور ضعيفة',
        'مشاكل إدارة الجلسة',
        'غياب المصادقة متعددة العوامل',
        'حقن بيانات الاعتماد',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 9,
    image: require('../../assets/img/bash/bash_course_logo.png'),
    link: '/bash-scripting',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Bash Scripting',
      description:
        'Develop efficient Bash scripts to automate tasks and system management.',
      topics: ['simple bash scripts', 'Variables', 'Parameters', 'Arrays'],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'برمجة Bash',
      description: 'قم بتطوير سكربتات Bash فعّالة لأتمتة المهام وإدارة النظام.',
      topics: ['سكريبتات Bash بسيطة', 'المتغيرات', 'المعلمات', 'المصفوفات'],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 10,
    image: require('../../assets/img/BLV/Landing.jpg'),
    link: '/BL_Vuln',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Business Logic Vulnerabilities',
      description:
        'Analyze business logic flaws, exploitation methods, and strategies for mitigation.',
      topics: [
        'Understanding Business Logic',
        'Identifying Flaws',
        'Exploitation Techniques',
        'Mitigation Strategies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'ثغرات منطق الأعمال',
      description:
        'حلل عيوب منطق الأعمال، طرق الاستغلال، واستراتيجيات التخفيف.',
      topics: [
        'فهم منطق الأعمال',
        'تحديد العيوب',
        'تقنيات الاستغلال',
        'استراتيجيات التخفيف',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 11,
    image: require('../../assets/img/IDOR/Insecure_Direct_Object_Reference.png'),
    link: '/Insecure_Direct_Object_Reference(IDOR)',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Insecure Direct Object Reference(IDOR)',
      description:
        'Explore IDOR vulnerabilities, unauthorized access, common examples, and mitigation strategies.',
      topics: [
        'What is IDOR?',
        'Why is it Dangerous?',
        'Common Examples.',
        'Exploitation Techniques.',
        'Mitigation Strategies.',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'مرجع الكائن المباشر غير الآمن (IDOR)',
      description:
        'استكشف ثغرات IDOR، الوصول غير المصرح به، أمثلة شائعة، واستراتيجيات التخفيف.',
      topics: [
        'ما هو IDOR؟',
        'لماذا هو خطير؟',
        'أمثلة شائعة',
        'تقنيات الاستغلال',
        'استراتيجيات التخفيف',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 12,
    image: require('../../assets/img/Obfuscation/card_image.png'),
    link: '/obfuscation',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Tools & Techniques',
      title: 'Obfuscation',
      description:
        'Learn code obfuscation techniques to protect intellectual property and security.',
      topics: [
        'What are Obfuscation & Deobfuscation?',
        'Why do we use Obfuscation?',
        'Javascript Obfuscation',
        'JS Deobfuscation Tools',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'الأدوات والتقنيات',
      title: 'إخفاء الشيفرة',
      description: 'تعلم تقنيات إخفاء الشيفرة لحماية الملكية الفكرية والأمان.',
      topics: [
        'ما هو الإخفاء وفك الإخفاء؟',
        'لماذا نستخدم الإخفاء؟',
        'إخفاء شيفرة Javascript',
        'أدوات فك إخفاء JS',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 13,
    image: require('../../assets/img/CSRF/landing.jpg'),
    link: '/CSRF',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Cross Site Request Forgery (CSRF)',
      description:
        'Understand CSRF attack vectors, mitigation techniques, and prevention best practices.',
      topics: [
        'Understanding CSRF',
        'Exploitation Methods',
        'Prevention Techniques',
        'Real-world Examples',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'تزوير طلب عبر المواقع (CSRF)',
      description: 'فهم طرق هجمات CSRF، تقنيات التخفيف، وأفضل ممارسات الوقاية.',
      topics: [
        'فهم CSRF',
        'طرق الاستغلال',
        'تقنيات الوقاية',
        'أمثلة من الواقع',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 14,
    image: require('../../assets/img/Path__Traversal/Photo_Content_Path_Traversal.png'),
    link: '/Path__Traversal',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Path Traversal',
      description:
        'Discover path traversal techniques and prevention measures for secure files.',
      topics: [
        'Path traversal techniques',
        'Directory traversal prevention',
        'Secure file access mechanisms',
        'Case Studies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'تجاوز المسارات',
      description:
        'اكتشف تقنيات تجاوز المسارات وإجراءات الوقاية للوصول الآمن للملفات.',
      topics: [
        'تقنيات تجاوز المسارات',
        'منع تجاوز المجلدات',
        'آليات وصول الملفات الآمنة',
        'دراسات حالة',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 15,
    image: require('../../assets/img/Cryptography/card_image.png'),
    link: '/cryptography',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Cryptography',
      description:
        'Master cryptography principles, encryption types, and techniques for secure communications.',
      topics: [
        'What is Cryptography?',
        'What is Steganography?',
        'How does Steganography differ from Cryptography?',
        'Types of Encryption',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'التشفير',
      description:
        'إتقان مبادئ التشفير، أنواع التشفير، وتقنيات الاتصالات الآمنة.',
      topics: [
        'ما هو التشفير؟',
        'ما هو التضمين الخفي؟',
        'كيف يختلف التضمين الخفي عن التشفير؟',
        'أنواع التشفير',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 16,
    image: require('../../assets/img/Regex/Landing.jpg'),
    link: '/Regex',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Regular expressions',
      description:
        'Craft effective regular expressions for text matching, searching, and parsing.',
      topics: [
        'Basics of Regex',
        'Character Classes',
        'Quantifiers and Grouping',
        'Practical Examples',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'التعابير النمطية',
      description: 'اصنع تعابير نمطية فعالة لمطابقة النصوص والبحث والتحليل.',
      topics: [
        'أساسيات Regex',
        'فئات الأحرف',
        'المحددات والتجميع',
        'أمثلة عملية',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 17,
    image: require('../../assets/img/Cross_Site_Scripting/xss.jpeg.jpg'),
    link: '/xss',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Cross-Site Scripting',
      description:
        'Identify and mitigate cross-site scripting risks in modern web applications.',
      topics: [
        'What is Cross-Site Scripting?',
        'Types of XSS',
        'Exploitation Techniques',
        'Mitigation Strategies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'البرمجة النصية عبر المواقع (XSS)',
      description:
        'تحديد وتقليل مخاطر البرمجة النصية عبر المواقع في التطبيقات الحديثة.',
      topics: [
        'ما هي البرمجة النصية عبر المواقع؟',
        'أنواع XSS',
        'تقنيات الاستغلال',
        'استراتيجيات التخفيف',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 18,
    image: require('../../assets/img/wireshark/card_image.png'),
    link: '/wireshark',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Tools & Techniques',
      title: 'Wireshark',
      description:
        'Utilize Wireshark for deep network traffic analysis and security monitoring.',
      topics: [
        'Wireshark Overview',
        'Collection Methods',
        'ARP Traffic',
        'ICMP & TCP Traffic',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الأدوات والتقنيات',
      title: 'وايرشارك',
      description:
        'استخدم Wireshark لتحليل حركة الشبكة العميقة ومراقبة الأمان.',
      topics: [
        'نظرة عامة على Wireshark',
        'طرق الجمع',
        'حركة مرور ARP',
        'حركة مرور ICMP وTCP',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 19,
    image: require('../../assets/img/Hashing/landing.jpg'),
    link: '/Hashing',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Hashing',
      description:
        'Understand hashing concepts, algorithms, security implications, and best practices thoroughly.',
      topics: [
        'Introduction to Hashing',
        'Common Hashing Algorithms',
        'Security Implications',
        'Best Practices',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'التجزئة (Hashing)',
      description:
        'فهم مفاهيم التجزئة، الخوارزميات، تبعات الأمان، وأفضل الممارسات بدقة.',
      topics: [
        'مقدمة في التجزئة',
        'الخوارزميات الشائعة للتجزئة',
        'تأثيرات الأمان',
        'أفضل الممارسات',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 20,
    image: require('../../assets/img/Command Injection/Content_Command_Injection.jpg'),
    link: '/Command_Injection',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Command Injection',
      description:
        'Learn command injection techniques, exploitation risks, and secure coding practices.',
      topics: [
        'Understanding Command Injection',
        'Networking Weaknesses',
        'Common Web Attacks',
        'Using the Linux OS',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'حقن الأوامر',
      description:
        'تعلم تقنيات حقن الأوامر، مخاطر الاستغلال، وممارسات البرمجة الآمنة.',
      topics: [
        'فهم حقن الأوامر',
        'نقاط ضعف الشبكة',
        'هجمات ويب شائعة',
        'استخدام نظام Linux',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 21,
    image: require('../../assets/img/File Inclusion/card_image.png'),
    link: '/fileinclusion',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'File Inclusion',
      description:
        'Examine file inclusion flaws, exploit methods, and robust remediation strategies.',
      topics: [
        'Path Traversal',
        'Local File Inclusion (LFI)',
        'Remote File Inclusion (RFI)',
        'Remediation',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'إدراج الملفات',
      description:
        'افحص عيوب إدراج الملفات، طرق الاستغلال، واستراتيجيات التصحيح القوية.',
      topics: [
        'تجاوز المسارات',
        'إدراج ملفات محلي (LFI)',
        'إدراج ملفات عن بعد (RFI)',
        'استراتيجيات التصحيح',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 22,
    image: require('../../assets/img/AudFor/landing.png'),
    link: '/Digital_Forensics',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Digital Forensics',
      description:
        'Investigate digital evidence using forensic techniques for accurate cyber investigations.',
      topics: [
        'Introduction to Digital Forensics',
        'Evidence Collection',
        'Analysis Techniques',
        'Case Studies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'التحقيق الرقمي',
      description:
        'تحقق من الأدلة الرقمية باستخدام تقنيات التحليل الجنائي لتحقيق تحقيقات سيبرانية دقيقة.',
      topics: [
        'مقدمة في التحليل الجنائي الرقمي',
        'جمع الأدلة',
        'تقنيات التحليل',
        'دراسات حالة',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 23,
    image: require('../../assets/img/Insecure_Deserialization/Content_Insecure_Photo.jpg'),
    link: '/Insecure_Deserialization',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Insecure Deserialization',
      description:
        'Detect insecure deserialization risks, prevent code execution, and secure data.',
      topics: [
        'Serialization and Deserialization',
        'Remote Code Execution (RCE)',
        'Data Tampering Techniques',
        'Preventing Insecure Deserialization',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'إلغاء التسلسل غير الآمن',
      description:
        'كشف مخاطر الإلغاء غير الآمن للتسلسل، منع تنفيذ الشيفرة، وتأمين البيانات.',
      topics: [
        'التسلسل وإلغاء التسلسل',
        'تنفيذ شيفرة عن بعد (RCE)',
        'تقنيات التلاعب بالبيانات',
        'منع الإلغاء غير الآمن للتسلسل',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 24,
    image: require('../../assets/img/Server Side Template Injection/card_image.png'),
    link: '/coming-soon',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Server Side Template Injection (SSTI)',
      description:
        'Understand SSTI risks, exploit techniques, and prevention strategies for templates.',
      topics: [
        'Introduction',
        'SSTI Vulnerabilities',
        'Constructing a SSTI Attack',
        'Prevention Strategies',
      ],
      difficulty: 'Intermediate',
      state: 'coming-soon',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'حقن قوالب من جانب الخادم (SSTI)',
      description:
        'فهم مخاطر SSTI، تقنيات الاستغلال، واستراتيجيات الوقاية للقوالب.',
      topics: ['مقدمة', 'ثغرات SSTI', 'إنشاء هجوم SSTI', 'استراتيجيات الوقاية'],
      difficulty: 'متوسط',
      state: 'قريباً',
    },
  },
  {
    id: 25,
    image: require('../../assets/img/Api_Hacking/landing.png'),
    link: '/Api_Hacking',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Tools & Techniques',
      title: 'API Hacking & Testing',
      description:
        'Master API hacking techniques, testing methodologies, and security assessment procedures.',
      topics: [
        'API Fundamentals',
        'Common Vulnerabilities',
        'Testing Tools',
        'Mitigation Strategies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الأدوات والتقنيات',
      title: 'اختراق واختبار API',
      description:
        'إتقان تقنيات اختراق API، منهجيات الاختبار، وإجراءات تقييم الأمان.',
      topics: [
        'أساسيات API',
        'الثغرات الشائعة',
        'أدوات الاختبار',
        'استراتيجيات التخفيف',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 26,
    image: require('../../assets/img/Condition_Race/Race Condition.png'),
    link: '/Race_Condition',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Race Condition',
      description:
        'A race condition occurs when multiple processes access shared resources simultaneously in an uncontrolled manner, leading to unexpected errors or security vulnerabilities.',
      topics: ['Topic 1', 'Topic 2', 'Topic 3', 'Topic 4'],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'حالة التنافس (Race Condition)',
      description:
        'تحدث حالة التنافس عندما تصل عمليات متعددة إلى الموارد المشتركة بشكل متزامن بطريقة غير مراقبة، مما يؤدي إلى أخطاء أو ثغرات أمنية غير متوقعة.',
      topics: ['الموضوع 1', 'الموضوع 2', 'الموضوع 3', 'الموضوع 4'],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 27,
    image: require('../../assets/img/Captcha Bypass/card_image.png'),
    link: '/captchabypass',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Captcha Bypass',
      description:
        'Examine captcha bypass methods, security flaws, and advanced prevention techniques.',
      topics: [
        'Introduction to Captcha',
        'Bypass Techniques',
        'Real-world Examples',
        'Prevention Strategies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'تجاوز الكابتشا',
      description:
        'افحص طرق تجاوز الكابتشا، العيوب الأمنية، وتقنيات الوقاية المتقدمة.',
      topics: [
        'مقدمة عن الكابتشا',
        'تقنيات التجاوز',
        'أمثلة من الواقع',
        'استراتيجيات الوقاية',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 28,
    image: require('../../assets/img/Click_Jacking/landing.jpg'),
    link: '/Click_Jacking',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'Click Jacking',
      description:
        'Investigate click jacking strategies, analyze attack mechanisms, and implement countermeasures.',
      topics: [
        'What is Click Jacking?',
        'Attack Techniques',
        'Prevention Methods',
        'Case Studies',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'اختطاف النقر (Click Jacking)',
      description:
        'تحقق من استراتيجيات اختطاف النقر، حلل آليات الهجوم، وطبق التدابير المضادة.',
      topics: [
        'ما هو اختطاف النقر؟',
        'تقنيات الهجوم',
        'طرق الوقاية',
        'دراسات حالة',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 29,
    image: require('../../assets/img/Server Side Template Injection/Untitled.png'),
    link: '/coming-soon',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fundamentals',
      title: 'Server Side Request Forgery (SSRF)',
      description:
        'Placeholder course offering preliminary topics, soon updated with comprehensive content.',
      topics: ['Topic 1', 'Topic 2', 'Topic 3', 'Topic 4'],
      difficulty: 'Hard',
      state: 'coming-soon',
    },
    ar_data: {
      category: 'الأساسيات',
      title: 'تزوير طلب من جانب الخادم (SSRF)',
      description:
        'دورة تجريبية تقدم مواضيع أولية، سيتم تحديثها قريباً بمحتوى شامل.',
      topics: ['الموضوع 1', 'الموضوع 2', 'الموضوع 3', 'الموضوع 4'],
      difficulty: 'صعب',
      state: 'قريباً',
    },
  },
  {
    id: 30,
    image: require('../../assets/img/JWT attacks/card_image.png'),
    link: '/coming-soon',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Vulnerabilities',
      title: 'JWT attacks',
      description:
        'Examine JWT attack vectors, token vulnerabilities, and secure handling methods.',
      topics: [
        'Introduction to JWT',
        'Common Attack Vectors',
        'Security Best Practices',
        'Mitigation Techniques',
      ],
      difficulty: 'Intermediate',
      state: 'coming-soon',
    },
    ar_data: {
      category: 'ثغرات',
      title: 'هجمات JWT',
      description: 'افحص طرق هجمات JWT، نقاط ضعف التوكن، وطرق التعامل الآمن.',
      topics: [
        'مقدمة عن JWT',
        'طرق الهجوم الشائعة',
        'أفضل ممارسات الأمان',
        'تقنيات التخفيف',
      ],
      difficulty: 'متوسط',
      state: 'قريباً',
    },
  },
  {
    id: 31,
    image: require('../../assets/img/Regex/Landing.jpg'),
    link: '/Regex',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'Fav Topics',
      title: 'Regular expressions',
      description:
        'Craft effective regular expressions for text matching, searching, and parsing.',
      topics: [
        'Basics of Regex',
        'Character Classes',
        'Quantifiers and Grouping',
        'Practical Examples',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'المواضيع المفضلة',
      title: 'التعابير النمطية',
      description: 'اصنع تعابير نمطية فعالة لمطابقة النصوص والبحث والتحليل.',
      topics: [
        'أساسيات Regex',
        'فئات الأحرف',
        'المحددات والتجميع',
        'أمثلة عملية',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
  {
    id: 32,
    image: require('../../assets/img/CSRF/landing.jpg'),
    link: '/CSRF',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'My Courses',
      title: 'Cross Site Request Forgery (CSRF)',
      description:
        'Understand CSRF attack vectors, mitigation techniques, and prevention best practices.',
      topics: [
        'Understanding CSRF',
        'Exploitation Methods',
        'Prevention Techniques',
        'Real-world Examples',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'دوراتي',
      title: 'تزوير طلب عبر المواقع (CSRF)',
      description: 'فهم طرق هجمات CSRF، تقنيات التخفيف، وأفضل ممارسات الوقاية.',
      topics: [
        'فهم CSRF',
        'طرق الاستغلال',
        'تقنيات الوقاية',
        'أمثلة من الواقع',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 33,
    image: require('../../assets/img/Burp_Suit/BurpSuit_Content.png'),
    link: '/Burp_Suit',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'My Courses',
      title: 'Burp Suite',
      description:
        'Master Burp Suite fundamentals, empowering cybersecurity testing and vulnerability assessment.',
      topics: [
        'Learn about different careers in cyber',
        'Hack your first application',
        'Defend against a live cyber attack',
        'Explore security topics in the industry',
      ],
      difficulty: 'Intermediate',
      state: 'published',
    },
    ar_data: {
      category: 'دوراتي',
      title: 'بورب سويت',
      description:
        'إتقان أساسيات Burp Suite، مما يمكّن من اختبار الأمن السيبراني وتقييم الثغرات.',
      topics: [
        'تعرف على المهن المختلفة في مجال الأمن السيبراني',
        'اخترق تطبيقك الأول',
        'الدفاع ضد هجوم إلكتروني مباشر',
        'استكشاف مواضيع الأمان في الصناعة',
      ],
      difficulty: 'متوسط',
      state: 'متاح',
    },
  },
  {
    id: 34,
    image: require('../../assets/img/cookies/Cookies_transparent.png'),
    link: '/cookies',
    favorite: false,
    myCourses: false,
    status: 'pending',

    access: 'free',
    en_data: {
      category: 'My Courses',
      title: 'Cookies',
      description:
        'Understand cookies’ roles, security implications, storage methods, and manipulation techniques.',
      topics: [
        'What Are Cookies?',
        'What are Cookies Used For?',
        'Where are Cookies Stored?',
        'Cookies Manipulation',
      ],
      difficulty: 'Beginner',
      state: 'published',
    },
    ar_data: {
      category: 'دوراتي',
      title: 'ملفات تعريف الارتباط (Cookies)',
      description:
        'فهم أدوار الكوكيز، تبعات الأمان، طرق التخزين، وتقنيات التلاعب بها.',
      topics: [
        'ما هي الكوكيز؟',
        'ما استخدام الكوكيز؟',
        'أين يتم تخزين الكوكيز؟',
        'تلاعب بالكوكيز',
      ],
      difficulty: 'مبتدئ',
      state: 'متاح',
    },
  },
];

export default courseData;
